export const APPOINTMENT_TYPE = {
  ONLINE: 'online',
  IN_PERSON: 'in_person',
};
